import Vue from 'vue';
import {makeRoute} from '$src/lib/helper';
import store from '$src/store';

function handleOnboardingBeforeEnter(to, from, next) {
    let user = store.getters['auth/getUser'];
    let hasOnboarding = (Vue.$is('student') || Vue.$is('alumni')) && ![0, null].includes(user.onboarding_type);

    if (to.name !== 'onboarding' && hasOnboarding) {
        next("/onboarding");
    } else if (to.name === 'onboarding' && !hasOnboarding) {
        next('/');
    } else {
        next();
    }
}

export default {
    routes: [
        {
            path: '/community',
            meta: {isAuth: true, hasRight: 'access_community'},
            component: () => import(/* webpackChunkName: "community" */ '$community/layouts/CommunityLayout'),
            beforeEnter: handleOnboardingBeforeEnter,
            children: [
                makeRoute('', 'community_home', () => import(/* webpackChunkName: "community" */ '$community/views/CommunityHomeView'), {
                    title: 'Startseite',
                }),

                makeRoute('search/:encoded_search_term?', 'community_search', () => import(/* webpackChunkName: "community" */ '$community/views/SearchView'), {
                    title: 'Suche',
                }),

                makeRoute('profile/:id_user', 'community_profile', () => import(/* webpackChunkName: "community" */ '$community/views/ProfileView'), {
                    title: 'Profil',
                    action: 'community/fetchProfile',
                }),

                makeRoute('profile/:id_user/edit/:section', 'community_profile_edit', () => import(/* webpackChunkName: "community" */ '$community/views/ProfileEditView'), {
                    title: 'Profil bearbeiten',
                    action: 'community/fetchProfile',
                }),

                makeRoute('events', 'community_event_overview', () => import(/* webpackChunkName: "community" */ '$community/views/EventsOverview'), {
                    title: 'Meine Termine',
                }),

                makeRoute('events/:id_event', 'community_event', () => import(/* webpackChunkName: "community" */ '$community/views/EventView'), {
                    title: 'Termin',
                    action: 'community/fetchEvent',
                }),

                makeRoute('events/:id_event/edit', 'community_event_edit', () => import(/* webpackChunkName: "community" */ '$community/views/EventEditView'), {
                    title: 'Termin bearbeiten',
                    action: 'community/fetchEvent',
                }),

                makeRoute('groups', 'community_group_overview', () => import(/* webpackChunkName: "community" */ '$community/views/GroupOverview'), {
                    title: 'Gruppe',
                }),

                makeRoute('groups/:id_group', 'community_group', () => import(/* webpackChunkName: "community" */ '$community/views/GroupView'), {
                    title: 'Gruppe',
                    action: 'community/fetchGroup',
                }),

                makeRoute('groups/:id_group/edit', 'community_group_edit', () => import(/* webpackChunkName: "community" */ '$community/views/GroupEditView'), {
                    title: 'Gruppe bearbeiten',
                    action: 'community/fetchGroup',
                }),

                makeRoute('balance/:id_user', 'community_balance', () => import(/* webpackChunkName: "community" */ '$community/views/BalanceView'), {
                    title: 'Bildungsgeld',
                    action: 'community/fetchBalance',
                }),

                makeRoute('user/:id_user/reports', 'community_reports_overview', () => import(/* webpackChunkName: "community" */ '$community/views/ReportsOverview'), {
                    title: 'Halbjahresberichte',
                    action: 'community/fetchReportList',
                }),

                makeRoute('report/:id_report', 'community_report_edit_view', () => import(/* webpackChunkName: "community" */ '$community/views/ReportEditView'), {
                    title: 'Halbjahresbericht bearbeiten',
                    action: 'community/fetchReport',
                }),

                makeRoute('news/:id_post', 'community_post_view', () => import(/* webpackChunkName: "community" */ '$community/views/PostView'), {
                    title: 'News-Beitrag',
                    action: 'community/fetchPost',
                }),

                makeRoute('user/:id_user/notes', 'community_notes_view', () => import(/* webpackChunkName: "community" */ '$community/views/NotesView'), {
                    title: 'Notizen',
                    action: 'community/getUserNotes',
                }),

                makeRoute('user/:id_user/events', 'community_user_events', () => import(/* webpackChunkName: "community" */ '$community/views/ProfileEventView'), {
                    title: 'Termine',
                    action: 'community/fetchProfile',
                }),

                makeRoute('group/:id_group/wiki/:id_wiki_page', 'community_wiki_page_view', () => import(/* webpackChunkName: "community" */ '$community/views/WikiPageView'), {
                    title: 'Wiki',
                    action: 'community/fetchWikiPage',
                }),

                makeRoute('group/:id_group/wiki', 'community_wiki_overview', () => import(/* webpackChunkName: "community" */ '$community/views/WikiOverview'), {
                    title: 'Wiki',
                    action: 'community/fetchWikiPage',
                }),

                makeRoute('group/:id_group/wiki/edit/:id_wiki_page', 'community_wiki_page_edit_view', () => import(/* webpackChunkName: "community" */ '$community/views/WikiPageEditView'), {
                    title: 'Wiki Seite bearbeiten',
                    action: 'community/fetchWikiPage',
                }),

                makeRoute('seminar/:id_seminar', 'community_seminar', () => import(/* webpackChunkName: "community" */ '$community/views/SeminarView'), {
                    title: 'Seminar',
                    action: 'community/fetchSeminar',
                }),
            ],
        },
        {
            name: 'onboarding',
            path: '/onboarding',
            component: () => import(/* webpackChunkName: "community" */ '$community/views/OnboardingView'),
            meta: {isAuth: true, hasRight: 'access_community'},
            beforeEnter: handleOnboardingBeforeEnter,
        },
        {
            path: '/survey/results/:id_survey_hash',
            component: () => import(/* webpackChunkName: "community" */ '$community/views/PublicSurveyResultsView'),
            props: true,
        },
    ],

    hooks: {
        async initialize() {
            await Promise.all([
                import(/* webpackChunkName: "community" */ '$community/components'),
                import(/* webpackChunkName: "community" */ '$community/components/forms'),
                import(/* webpackChunkName: "community" */ '$community/components/profile-sections'),
                import(/* webpackChunkName: "community" */ '$src/components/filter'),
                import(/* webpackChunkName: "community" */ '$src/components/form'),
                import(/* webpackChunkName: "community" */ '$community/modules'),
                import(/* webpackChunkName: "community" */ '$community/modals'),
            ]);
        },
        beforeEnter() {
            this.$ui.titleTemplate = '%s - Wir sind START';
            this.$ui.defaultTitle = 'Wir sind START';
        },
    },
};